import styled from 'styled-components';

const Strong = styled.strong`
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.bodyMd};
    line-height: 24px;
    color: ${({ theme }) => theme.darkText};
`;

export default Strong;